import type {
  BooksHealthOverviewDTO,
  BooksHealthSummaryDTO,
  BooksMonthStatusItemDTO,
  RecentBooksActivityDTO,
} from "../models/booksHealthDto";
import type {
  BooksHealthOverviewEntity,
  ActionRequiredItemEntity,
  BooksHealthSummaryEntity,
  BooksMonthStatusItemEntity,
  MonthlyModuleStatusEntity,
  RecentBooksActivityEntity,
} from "../../domain/entities/BooksHealthEntity";

export function actionRequiredItemDtoToEntity(
  dto: BooksHealthOverviewDTO["action_required_items"][0],
): ActionRequiredItemEntity {
  return {
    id: dto.id,
    title: dto.title,
    description: dto.description,
    raisedBy: dto.raised_by,
    date: dto.date,
    type: dto.type,
    actionTarget: dto.action_target,
  };
}

export function booksHealthSummaryDtoToEntity(
  dto: BooksHealthSummaryDTO,
): BooksHealthSummaryEntity {
  return {
    status: dto.status,
    reconciledThroughMonth: dto.reconciled_through_month,
    currentMonthLabel: dto.current_month_label,
    currentMonthProgressPercent: dto.current_month_progress_percent,
    projectedCloseDate: dto.projected_close_date,
    summaryText: dto.summary_text,
    infoNote: dto.info_note,
  };
}

export function booksMonthStatusItemDtoToEntity(
  dto: BooksMonthStatusItemDTO,
): BooksMonthStatusItemEntity {
  return {
    monthLabel: dto.month_label,
    yearLabel: dto.year_label ?? "",
    status: dto.status,
    percentComplete: dto.percent_complete,
  };
}

function moduleStatusDtoToEntity(dto: BooksHealthOverviewDTO["monthly_module_status"][0]): MonthlyModuleStatusEntity {
  return {
    module: dto.module,
    label: dto.label,
    completed: dto.completed,
    total: dto.total,
    pendingLabel: dto.pending_label,
    isComplete: dto.is_complete,
  };
}

export function monthlyModuleStatusDtoToEntity(
  dto: import("../models/booksHealthDto").MonthlyModuleStatusDTO,
): MonthlyModuleStatusEntity {
  return {
    module: dto.module,
    label: dto.label,
    completed: dto.completed,
    total: dto.total,
    pendingLabel: dto.pending_label,
    isComplete: dto.is_complete,
  };
}

function activityDtoToEntity(dto: BooksHealthOverviewDTO["recent_activity"][0]): RecentBooksActivityEntity {
  return {
    date: dto.date,
    description: dto.description,
    userName: dto.user_name,
  };
}

export function recentBooksActivityDtoToEntity(
  dto: RecentBooksActivityDTO,
): RecentBooksActivityEntity {
  return {
    date: dto.date,
    description: dto.description,
    userName: dto.user_name,
  };
}

export function booksHealthOverviewDtoToEntity(dto: BooksHealthOverviewDTO): BooksHealthOverviewEntity {
  return {
    actionRequiredItems: dto.action_required_items.map(actionRequiredItemDtoToEntity),
    summary: booksHealthSummaryDtoToEntity(dto.summary),
    monthByMonthStatus: dto.month_by_month_status.map(booksMonthStatusItemDtoToEntity),
    monthlyModuleStatus: dto.monthly_module_status.map(moduleStatusDtoToEntity),
    recentActivity: dto.recent_activity.map(activityDtoToEntity),
    lastUpdated: dto.last_updated,
    lastUpdatedBy: dto.last_updated_by,
  };
}
